export default "__VITE_ASSET__CmVh5TKP__"